import classnames from 'classnames';
import React from 'react';
import { Button as BButton } from 'react-bootstrap';

import { Icon } from './Icon';

export interface ButtonProps {
  label: string;
  onClick?: () => void;
  icon?: string;
  trapezoid?: boolean;
  shapeReverse?: boolean;
  disabled?: boolean;
  variant?: 'primary' | 'secondary' | 'subtle' | 'link';
  outline?: boolean;
  href?: string;
  target?: string;
  size?: 'sm' | 'lg' | undefined;
  className?: string;
  id?: string;
  type?: 'button' | 'submit' | 'reset' | undefined;
  onMouseDown?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  isPulsing?: boolean;
}

export const Button: React.FC<ButtonProps> = (props) => {
  if (props.trapezoid) {
    return <IrregularShapeButton {...props} />;
  }
  return <RegularButton {...props} />;
};

const RegularButton: React.FC<ButtonProps> = ({
  variant,
  size,
  label,
  icon,
  outline,
  className,
  isPulsing,
  ...props
}) => {
  let newVariant = null;
  if (variant && outline) {
    newVariant = `outline-${variant}`;
  }

  return (
    <BButton
      size={size}
      variant={newVariant || variant}
      className={classnames(className, isPulsing && `btn-is-pulsing`)}
      {...props}
    >
      <span>{label}</span>
      <Icon name={icon} />
    </BButton>
  );
};

const IrregularShapeButton: React.FC<ButtonProps> = ({
  variant,
  shapeReverse,
  icon,
  label,
  size,
  ...props
}) => {
  const primary = variant === 'primary';
  const content = (
    <>
      <Icon name={icon} className={classnames(!primary && 'text-blue-main')} />
      <span>{label}</span>
    </>
  );
  return (
    <BButton
      {...props}
      size={size}
      variant={primary ? 'primary' : undefined}
      className={classnames('btn-trapezoid', shapeReverse && 'btn-trapezoid-reverse')}
    >
      {content}{' '}
      {/** behind the ::after style, so it's used to set the width/height automatically */}
      <div className="btn-trapezoid-content">{content}</div>{' '}
      {/** the content that is actually rendered */}
    </BButton>
  );
};
